module.exports = __webpack_public_path__ + "static/media/badge-google-keyword.324910b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/badge-google-keyword.png
// module id = 305
// module chunks = 0